import { AppContext } from "01Data/AppData";
import {
  ExpandLess,
  ExpandMore,
  ManageAccounts,
  People,
  Settings,
} from "@mui/icons-material";
import ApartmentIcon from "@mui/icons-material/Apartment";
import HomeIcon from "@mui/icons-material/Home";
import IconLogout from "@mui/icons-material/Logout";
import UserIcon from "@mui/icons-material/Person";
import IconView from "@mui/icons-material/Visibility";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
} from "@mui/material";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";

const MyLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  color: theme.palette.text.secondary,
}));

const MyList = styled(List)(({ theme }) => ({
  width: "240px",
}));

type Props = {
  name: string;
  path: string;
  icon: any;
  onClick?: any;
  reload?: boolean;
};

const Item = (props: Props) => {
  const handleOnClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <MyLink
      to={props.path}
      key={props.path}
      onClick={handleOnClick}
      reloadDocument={props.reload}
    >
      <ListItemButton>
        <ListItemIcon>{props.icon}</ListItemIcon>
        <ListItemText primary={props.name} />
      </ListItemButton>
    </MyLink>
  );
};

const MenuItem = (props: any) => {
  const a = useContext(AppContext).account;
  const [bShowSettings, setShowSettings] = useState(false);

  const handleLogout = () => {
    a.SignOut();
  };

  const handleDrawerClose = () => {
    props.handleDrawerClose();
  };

  return (
    <MyList>
      <Item
        name="トップ"
        path="/top"
        icon={<HomeIcon />}
        onClick={handleDrawerClose}
        reload
      />
      <ListItemButton onClick={() => setShowSettings(!bShowSettings)}>
        <ListItemIcon>
          <Settings />
        </ListItemIcon>
        <ListItemText primary="設定" />
        {bShowSettings ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse
        sx={{ padding: "0 20px 0" }}
        in={bShowSettings}
        timeout="auto"
        unmountOnExit
      >
        <Item
          name="ユーザー設定"
          path="/settings/user"
          icon={<UserIcon />}
          onClick={handleDrawerClose}
        />
        {a.IsUserViewer() ? null : (
          <Item
            name="アカウント設定"
            path="/settings/accounts"
            icon={<ManageAccounts />}
            onClick={handleDrawerClose}
          />
        )}
        {a.IsUserAdmin() || a.IsUserSubAdmin() ? (
          <Item
            name="アカウント一覧"
            path="/settings/all-accounts"
            icon={<People />}
            onClick={handleDrawerClose}
          />
        ) : null}
        <Item
          name="表示・通知設定"
          path="/settings/permissions"
          icon={<IconView />}
          onClick={handleDrawerClose}
        />
      </Collapse>
      <Item
        name="建物一覧"
        path="/buildings"
        icon={<ApartmentIcon />}
        onClick={handleDrawerClose}
      />
      <Item
        name="ログアウト"
        path="/login"
        icon={<IconLogout />}
        onClick={handleLogout}
      />
    </MyList>
  );
};

export default MenuItem;
